import React, { useState } from "react";
import PropTypes from "prop-types";
import HeaderMenu from "../../organisms/HeaderMenu";
import UserAvatarWithName from "../../molecules/UserAvatarWithName";
import { Flex } from "@fluentui/react-northstar";
import { observer } from "mobx-react";

const Header = observer((props) => {
  const {
    signOutClicked,
    settingsClicked,
    currentUser,
    setRegistered,
    locations,
    setLocation,
  } = props;
  const [isOpen, setIsOpen] = useState(false);

  const onClickHandler = () => {
    setIsOpen(!isOpen);
  };

  const settingsClickedHandler = () => {
    setIsOpen(false);
    if (settingsClicked) {
      settingsClicked(true);
    }
  };

  return (
    <Flex gap="gap.smaller" column hAlign="end" data-testid="headerContainer">
      <UserAvatarWithName name={currentUser.name} onClick={onClickHandler} />
      {isOpen ? (
        <HeaderMenu
          signOutClicked={signOutClicked}
          settingsClicked={settingsClickedHandler}
          currentUser={currentUser}
          setRegistered={setRegistered}
          locations={locations}
          setLocation={setLocation}
        />
      ) : null}
    </Flex>
  );
});

Header.propTypes = {
  signOutClicked: PropTypes.func,
  settingsClicked: PropTypes.func,
  setRegistered: PropTypes.func,
  currentUser: PropTypes.object,
  locations: PropTypes.array,
  setLocation: PropTypes.func,
};

Header.defaultProps = {
  currentUser: {},
  locations: [],
};

export default Header;
